import { Alert, Button, Form, Input } from "antd";
import { getCapitalizedString, getLowerCaseString } from "../../helpers/StringFormatHelper";
import { isValidValue, setFormFieldValue } from "../../helpers/FormHelper";
import { useState } from "react";
import { getErrorMessage } from "../../helpers/ApiResponseHelper";
import MemberServiceInstance from "../../services/MemberService";
import { FaCheck } from "react-icons/fa";

export default function ModalRegister({ isRegister, handleRegister, handleLogin, }) {
	const [submitLoading, setSubmitLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(null);
	const hasError = isValidValue(errorMessage);
	const [form] = Form.useForm();

	const formatRequestData = (data) => {
		return {
			name: getCapitalizedString(data.name),
			surname: getCapitalizedString(data.surname),
			fullName: getCapitalizedString(data.name) + ' ' + getCapitalizedString(data.surname),
			initials: getCapitalizedString(data.name)?.charAt(0) + getCapitalizedString(data.surname)?.charAt(0),
			email: getLowerCaseString(data.email),
			password: setFormFieldValue(data.password),
		};
	};

	const onRegister = async () => {
		try {
			setSubmitLoading(true);
			const data = await form.validateFields();
			const requestData = formatRequestData(data);
			const response = await MemberServiceInstance.register(requestData);
			const responseData = response?.data;
			const { success, message } = responseData;
			if (success === true) {
				form.resetFields();
				handleRegister();
				handleLogin();
			} else {
				const errorMsg = isValidValue(message) ? message : 'Registration failed. Please try again.';
				setErrorMessage(errorMsg);
			}
		} catch (error) {
			if (error?.values) {
				setSubmitLoading(false);
				return;
			}

			const errorMessage = getErrorMessage(error?.response, error?.message);
			setErrorMessage(errorMessage);
		} finally {
			setSubmitLoading(false);
		}
	};

	return (
		<>
			<div className={`modal fade modal-login ${isRegister ? "show d-block" : ""}`} id="exampleModalToggle2" aria-hidden="true" aria-label="exampleModalToggleLabel2" tabIndex={-1}>
				<div className="modal-dialog modal-dialog-centered">
					<div className="modal-content">
						<button type="button" className="btn-close" onClick={handleRegister} aria-label="Close" />
						<div className="tfre_registration-form register-modal">
							<h2>Register:</h2>
							<div className="error_message tfre_message" />
							<Form form={form} layout="vertical" className="tfre_register" encType="multipart/form-data" id="tfre_custom-register-form">
								<div className="container">
									<div className="row">
										<div className="col-md-6">
											<Form.Item name="name" className="form-group" label="First Name:" rules={[{ required: true, message: 'Please input your first name!' }]}>
												<Input type="text" name="name" id="name" placeholder="First name" required />
											</Form.Item>
										</div>
										<div className="col-md-6">
											<Form.Item name="surname" className="form-group" label="Last Name:" rules={[{ required: true, message: 'Please input your last name!' }]}>
												<Input type="text" name="surname" id="surname" placeholder="Last name" required />
											</Form.Item>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<Form.Item name="email" className="form-group" label="Email:" rules={[{ required: true, message: 'Please input your email!', type: 'email' }]}>
												<Input type="email" name="email" id="email" placeholder="Your email address" required />
											</Form.Item>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<Form.Item name="password" className="form-group" style={{ border: 'none' }} label="Password:" rules={[{ required: true, message: 'Please input your password!' }]}>
												<Input.Password name="password" id="password" placeholder="Password" required />
											</Form.Item>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<Form.Item name="confirmPassword" className="form-group" label="Confirm Password:" dependencies={['password']} hasFeedback rules={[
												{ required: true, message: 'Please confirm your password!' },
												({ getFieldValue }) => ({ validator(_, value) { if (!value || getFieldValue('password') === value) { return Promise.resolve(); } return Promise.reject(new Error('The two passwords that you entered do not match!')); }, }),
											]}>
												<Input.Password name="confirmPassword" id="confirmPassword" placeholder="Confirm Password" required />
											</Form.Item>
										</div>
									</div>
								</div>
								{hasError === true && (
									<div className="row">
										<div className="col-12">
											<Alert message={errorMessage} type="error" showIcon closable onClose={() => setErrorMessage(null)} />
										</div>
									</div>
								)}
								<div className="tfre_register-submit">
									{hasError && <div className="error-message" style={{ marginBottom: 10 }}>{errorMessage}</div>}
									<Button onClick={onRegister} block loading={submitLoading} type="submit" style={{ minHeight: '50px' }} icon={<FaCheck style={{ marginRight: '10px' }} />} className="flat-button">
										{submitLoading === false && 'Register'}
									</Button>
								</div>
							</Form>
						</div>
						<div className="container tfre_signin tfre_login_redirect cursor-pointer text-center" id="tfre_login_redirect">
							<p>Already have an account? <a onClick={() => { handleLogin(); handleRegister() }} style={{ cursor: 'pointer' }} className="tfre_register">Sign in.</a></p>
						</div>
					</div>
				</div>
			</div>
			{isRegister &&
				<div className={`modal-backdrop fade show`} onClick={handleRegister} />
			}
		</>
	)
}
